var exports = {
  "kL": "container__TkCXlq",
  "Kk": "icon__tupoaB",
  "a6": "sso__tvK2-v",
};

module.exports = exports;
